import { styled } from 'styled-system/jsx'

const ConfirmationColumn = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '100%',
  },
})

const SuccessHeader = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
})

const SuccessHeadline = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: { base: '20px', md: '24px' },
    fontWeight: 600,
    color: 'app.fg',
    margin: 0,
  },
})

const SuccessSubline = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'app.fgMuted',
  },
})

const SummaryCard = styled('div', {
  base: {
    border: '1px solid',
    borderColor: 'app.border',
    borderRadius: 'md',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    backgroundColor: 'book.surfaceMuted',
  },
})

const SummaryRow = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
})

const SummaryLabel = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: 600,
    color: 'app.fgMuted',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
})

const SummaryValue = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'app.fg',
  },
})

const CalendarButtonsRow = styled('div', {
  base: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
})

const CalendarLink = styled('a', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: 600,
    padding: '8px 14px',
    border: '1px solid',
    borderColor: 'app.border',
    borderRadius: 'md',
    backgroundColor: 'app.surface',
    color: 'app.fg',
    textDecoration: 'none',
    cursor: 'pointer',
    _hover: {
      backgroundColor: 'book.primarySoft',
      borderColor: 'app.accent',
      color: 'app.accent',
    },
  },
})

const JoinMeetingLink = styled('a', {
  base: {
    display: 'inline-block',
    backgroundColor: 'app.accent',
    color: '#ffffff',
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: 600,
    padding: '8px 14px',
    borderRadius: 'md',
    textDecoration: 'none',
    width: 'fit-content',
    transition: 'opacity 160ms',
    _hover: { opacity: 0.85 },
  },
})

const ManageLinksRow = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    fontFamily: 'body',
    fontSize: '13px',
    color: 'app.fgMuted',
    paddingTop: '8px',
    borderTop: '1px solid',
    borderColor: 'app.border',
    '& a': {
      color: 'app.accent',
      textDecoration: 'underline',
    },
  },
})

export {
  ConfirmationColumn,
  SuccessHeader,
  SuccessHeadline,
  SuccessSubline,
  SummaryCard,
  SummaryRow,
  SummaryLabel,
  SummaryValue,
  CalendarButtonsRow,
  CalendarLink,
  JoinMeetingLink,
  ManageLinksRow,
}
